import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'academic-schedule'
const initialState = {
  list: null,
  scheduleList: null,
  loading: false,
}

export const search = createApiAction('attendance/schedule/search', client.search('/api/attendance/schedule'))
export const employeeSchedule = createApiAction('attendance/schedule/employeeSchedule', client.retrieve('/api/member/:type/:memberId/schedule/:markingPeriodId'))
export const getSchedule = createApiAction('attendance/schedule/getSchedule', client.retrieve('/api/member/:type/:memberId/schedule/:markingPeriodId'))

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {
    updateAttendanceTakenPeriods: (state, action) => {
      const { periodId, isChecked } = action.payload
      state.list.attendanceTakenPeriods = state.list.attendanceTakenPeriods.map(item =>
        item.periodId === periodId ? { ...item, isChecked } : item,
      )
    },
  },
  extraReducers(builder) {
    builder.addCase(search.pending, (state) => {
      state.loading = true
    })
    builder.addCase(search.fulfilled, (state, action) => {
      state.list = action.payload
      state.loading = false
    })
    builder.addCase(getSchedule.fulfilled, (state, action) => {
      state.scheduleList = action.payload
    })
  },
})
export const { updateAttendanceTakenPeriods } = sessionSlice.actions

export default sessionSlice.reducer
